import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { componentDestroyed, Game, MediaItem, UntilDestroy } from '@mtgame/core';
import { GameMediaService } from '@core/services/game-media.service';
import { DialogService } from '@mtgame/ui';
import { combineLatest } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { SeoService } from '@core/services/seo.service';
import { GameRootService } from '@core/services/game-root.service';

@UntilDestroy
@Component({
  selector: 'mtg-tournament-game-live',
  templateUrl: './tournament-game-live.component.html',
  styleUrls: ['./tournament-game-live.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentGameLiveComponent implements OnInit, OnDestroy {
  videos: MediaItem[];
  game: Game;
  liveVideos: MediaItem[];

  constructor(
    private gameRootService: GameRootService,
    private gameMediaService: GameMediaService,
    private cdr: ChangeDetectorRef,
    private dialogService: DialogService,
    private seoService: SeoService,
  ) {
  }

  ngOnInit(): void {
    this.gameRootService.game$
      .pipe(take(1))
      .subscribe(game => {
        const title = `Трансляция. Игра ${game.team.name} против ${game.competitorTeam.name}`;
        this.seoService.setData({title});
      });
    combineLatest([
      this.gameRootService.game$.pipe(takeUntil(componentDestroyed(this))),
      this.gameMediaService.media$.pipe(takeUntil(componentDestroyed(this)))
    ]).subscribe(([game, media]) => {
      this.game = game;
      this.videos = media.filter(item => item.isVideo && !item.isLive);
      this.liveVideos = media.filter(item => item.isVideo && item.isLive);
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
  }
}
